import { OnInit, ElementRef } from '@angular/core';
import { ProjectsService } from "app/main/Services/projects.service";
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { SendMessageComponent } from './popup/send-message/send-message.component';
import { environment } from 'environments/environment';
import { DataService } from 'app/main/Services/data.service';
import { ActivatedRoute } from '@angular/router';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
var SmsConversationComponent = /** @class */ (function () {
    function SmsConversationComponent(projectsService, data, route, formBuilder, dialog) {
        this.projectsService = projectsService;
        this.data = data;
        this.route = route;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.heroes = [];
        this.searchText = "";
        this.BaseNumber = '';
        this.BaseNumber = environment.BaseNumber;
    }
    SmsConversationComponent.prototype.ngOnInit = function () {
        this.id = this.route.snapshot.params['id'];
        if (this.id) {
            this.fromNumber = this.id;
        }
        this.getSms();
        this.heroForm = this.formBuilder.group({
            body: this.formBuilder.control('', [Validators.required]),
        });
    };
    SmsConversationComponent.prototype.getSms = function () {
        var _this = this;
        this.projectsService.getSms().subscribe(function (heroes) {
            _this.heroes = [];
            heroes.data.forEach(function (element) {
                _this.heroes.push(element);
            });
            if (_this.fromNumber === undefined) {
                _this.getHero(_this.heroes[0].recipient);
            }
            else {
                _this.getHero(_this.fromNumber);
            }
        });
    };
    SmsConversationComponent.prototype.getHero = function (id) {
        var _this = this;
        this.fromNumber = id;
        this.projectsService.getSmsHero(id).subscribe(function (response) {
            var hero = response.sms_conversations;
            var herolength = Object.keys(hero).length;
            for (var i = 0; i < herolength; ++i) {
                if (hero[i]["attachment"] != null) {
                    var attachvar = hero[i]["attachment"];
                    var obj = JSON.parse(attachvar);
                    hero[i]["attachment"] = obj;
                }
                else {
                }
            }
            _this.hero = hero;
            // this.newMessage();
            var scrollerHeight = _this.myScrollContainer.nativeElement.offsetHeight;
            _this.chatPS1.directiveRef.scrollToTop(scrollerHeight * 100, 100);
        });
    };
    SmsConversationComponent.prototype.sendSmsto = function () {
        var _this = this;
        if (this.heroForm.valid) {
            var obj = {
                recipient: this.fromNumber,
                body: this.heroForm.value.body
            };
            this.projectsService.sendSmsto(obj)
                .subscribe(function (response) {
                _this.heroForm.reset(undefined);
                // this.getHero(this.fromNumber);
                _this.getSms();
            });
        }
    };
    // popup
    SmsConversationComponent.prototype.sendMessagePopup = function () {
        var _this = this;
        var dailogRef = this.dialog.open(SendMessageComponent, {
            width: '500px'
        });
        dailogRef.afterClosed().subscribe(function (response) {
            if (response) {
                // this.getProjectDetail();
                _this.getSms();
            }
        });
    };
    SmsConversationComponent.prototype.newMessage = function () {
        this.data.changeMessage("sms");
    };
    SmsConversationComponent.prototype.markAsRead = function () {
        var _this = this;
        var obj = {
            recipient: this.fromNumber
        };
        this.projectsService.markAsReadSms(obj)
            .subscribe(function (response) {
            // this.getHero(this.fromNumber);
            _this.getSms();
            _this.newMessage();
        });
    };
    SmsConversationComponent.prototype.pageRefresh = function () {
        this.getSms();
        this.newMessage();
    };
    return SmsConversationComponent;
}());
export { SmsConversationComponent };
